import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { authRoutes, routes } from "./pages/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./css/style.css";

const App = () => {
  const admin = localStorage && JSON.parse(localStorage.getItem("adminData"));
  return (
    <Routes>
      {admin !== null ? (
        <>
          <Route path="*" element={<Navigate replace to="/customers" />} />
        </>
      ) : (
        <>
          {authRoutes.map((data, index) => (
            <Route
              onUpdate={() => window.scrollTo(0, 0)}
              exact={true}
              path={data.path}
              element={data.component}
              key={index}
            />
          ))}
        </>
      )}

      {admin !== null &&
        routes.map((data, index) => (
          <Route path={data.path} element={data.component} key={index} />
        ))}

      {admin == null && (
        <Route path="*" element={<Navigate replace to="/" />} />
      )}
    </Routes>
  );
};

export default App;
